import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { ActionsPropsInterface } from './ActionsTypes';
import * as Styled from './ActionsStyles';

function Actions({ text, onClick }: ActionsPropsInterface) {
  if (!text || !onClick) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <FuelButton onClick={() => onClick()} fullWidth size="small">
        {text}
      </FuelButton>
    </Styled.Wrapper>
  );
}

export default Actions;
